import Question from "../../../generated/images/Question";
import ImportantIcon from "../../../generated/images/ImportantIcon";

import { useRootStore } from "../../stores/hooks";
import { observer } from "mobx-react-lite";
import { StyledCheckboxSection, StyledDialogImage } from "./style";
import { StyledHDivider } from "../../containers/AutomationForm/Header/style";
import { useOnClickOutside } from "../../utils/hooks";
import { useRef } from "react";
import { t } from "i18next";
import {
  Checkbox,
  Dialog,
  ModalOverlay,
  Paragraph,
  RoundButton,
  roundButtonStylesLarge,
} from "@smartsuite/react-ui/lib";
import { globalDropdownsZIndex } from "@smartsuite/react-ui/lib/constants/zIndex";
import { Colors } from "@smartsuite/types";

export const ConfirmModal = observer<Record<string, never>>(() => {
  const store = useRootStore().modal;
  const modalRef = useRef(null);

  useOnClickOutside(modalRef, () => {
    if (
      store.modal.closeOnClickOutside === undefined ||
      store.modal.closeOnClickOutside
    ) {
      store.closeConfirmModal();
    }
  });

  return (
    <ModalOverlay
      animation="none"
      active={store.open}
      closeByEsc={false}
      zIndex={globalDropdownsZIndex + 1}
    >
      <div ref={modalRef}>
        <Dialog.Wrapper size={store.modal.size} type={store.modal.type}>
          {/* Dialog.Image doesn't work with our builder */}
          <StyledDialogImage>
            {store.modal.type === "warning" && <Question />}
            {store.modal.type === "confirm" && <ImportantIcon />}
          </StyledDialogImage>
          <Dialog.Header>
            {store.modal.title != null && (
              <Dialog.Header.Heading text={store.modal.title} />
            )}
            {store.modal.description != null && (
              <Dialog.Header.Description text={store.modal.description} />
            )}
          </Dialog.Header>
          {store.modal.body != null && (
            <Dialog.Body fullWidth>{store.modal.body}</Dialog.Body>
          )}
          <Dialog.Footer>
            {store.modal.hasUnsavedChanges !== undefined &&
            store.modal.hasUnsavedChanges ? (
              <>
                <RoundButton
                  styles={{
                    ...roundButtonStylesLarge,
                    ...{
                      background: Colors.bRed,
                      backgroundHover: Colors.dRed,
                    },
                  }}
                  onClick={store.modal.onClose}
                >
                  {store.modal.negativeButtonText}
                </RoundButton>
                <StyledHDivider marginL={10} />
                <RoundButton
                  styles={{
                    ...roundButtonStylesLarge,
                    ...{
                      background: Colors.bGreen,
                      backgroundHover: Colors.dGreen,
                    },
                  }}
                  onClick={store.modal.onConfirm}
                >
                  {store.modal.positiveButtonText}
                </RoundButton>
              </>
            ) : (
              <>
                <Dialog.Footer.CancelButton
                  text={store.modal.negativeButtonText}
                  onClick={
                    store.modal.isLoading === true
                      ? undefined
                      : store.modal.onClose
                  } // "disabled" not works for some reasons
                />
                <Dialog.Footer.ConfirmButton
                  warningBackground={store.modal.type === "warning"}
                  text={store.modal.positiveButtonText}
                  onClick={store.modal.onConfirm}
                  loading={store.modal.isLoading}
                />
              </>
            )}
          </Dialog.Footer>
          {store.modal.showCheckbox === true && (
            <StyledCheckboxSection>
              <Checkbox onChange={store.modal.onChangeCheckbox} />
              <Paragraph> {t("confirm-modal.dont-show-again")}</Paragraph>
            </StyledCheckboxSection>
          )}
        </Dialog.Wrapper>
      </div>
    </ModalOverlay>
  );
});
